import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Stack, Tooltip, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { prettyPrintDate } from "util/dates";

import { utcDueDateTooltip } from "./helpers/dueDateWarnings";

export function DueDateColumnHeader({ label }: { label: string }) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2" fontWeight={500}>
        {label}
      </Typography>
      <Tooltip placement="right" title={utcDueDateTooltip(DateTime.utc().startOf("day"))}>
        <InfoOutlined sx={{ fontSize: 16, color: "text.secondary" }} />
      </Tooltip>
    </Stack>
  );
}

/**
 * A reviewer's or signer's due date, with the validation error or the
 * grandfathered-date warning beneath it. An error wins when both apply.
 */
export function DueDateWithMessage({
  dueDate,
  errorMessage,
  warningMessage,
}: {
  dueDate?: DateTime | null;
  errorMessage?: string;
  warningMessage?: string;
}) {
  const message = errorMessage ?? warningMessage;

  return (
    <Stack justifyContent="center" sx={{ height: "100%" }}>
      <Typography variant="body2">{dueDate ? prettyPrintDate(dueDate.toISO()) : ""}</Typography>
      {message && (
        <Tooltip title={message}>
          <Typography
            variant="caption"
            noWrap
            sx={{ color: errorMessage ? "error.main" : "warning.dark" }}
          >
            {message}
          </Typography>
        </Tooltip>
      )}
    </Stack>
  );
}
